import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const PickupZipcode = (props) => {
  const { translations, pickUp, zipCode, countryCode, } = props;

  const countryName =  useMemo(() => {
    switch (countryCode) {
      case 'pl':
        return 'poland'
      case 'fr':
        return 'france'
      case 'au':
        return 'austria'
      default:
        return 'germany'
    }
  }, [countryCode])

  const shouldZipCodeShow = pickUp || zipCode;
  return (
    <div className="col-md-12 details__pickupidate details__bottom-line">
      <span className="details-label">{translations}</span>
      {shouldZipCodeShow && <a href={`https://www.google.com/maps/place/${zipCode}+${countryName}`} target="_blank" rel="noreferrer" className="details-description-pickup-zipcode">{pickUp} / {zipCode}</a>}
      <style jsx="true">
        {`
          .details-label {
            display: block;
            text-align: left;
            margin-bottom: 5px;
            font-size: 13px;
            font-weight: 600;
            color: #b0acb7;
          }
          .details-description-pickup-zipcode {
            font-size: 15px;
            font-weight: 500;
            cursor: pointer;
          }
          .details-description-pickup-zipcode:hover {
            text-decoration: none;
          }
          .details__bottom-line {
            padding-bottom: 40px;
            border-bottom: 1px solid #ebeaee;
          }
        `}
      </style>
    </div>
  );
};

PickupZipcode.propTypes = {
  translations: PropTypes.string.isRequired,
  countryCode: PropTypes.string,
  pickUp: PropTypes.string,
  zipCode: PropTypes.string,
};

PickupZipcode.defaultProps = {
  pickUp: null,
  zipCode: null,
  countryCode: null,
};

export default PickupZipcode;
